var flowConfigParser = require('./lib/flowConfigParser');

module.exports = flowConfigParser;


//////////////////
// WEBPACK FOOTER
// ../flow-config-parser/flow-config-parser.js
// module id = 256
// module chunks = 0